import './styles.css';
import Home from './pages/Home.jsx';

function App() {
  return <Home />;
}

export default App;
